export default __webpack_public_path__ + "static/media/dc.40cf3755.svg";